import { Box, Typography } from "@mui/material";
import SCSLogo from "../../../assets/images/icons/SCS-RecycledMaterialLogo.png";
import HarmonyIcon from "../../../assets/images/icons/icon-harmony.svg";
import { Link as DomLink } from "react-router-dom";

export default function HarmonyMetalInfoBox({ extraText, adjustedHeight }) {
  return (
    <Box
      sx={{
        border: "1px solid #e0e0e0",
        display: "flex",
        alignItems: "center", // vertical center
        paddingRight: 2, // horizontal padding
        marginTop: 2, // space above the box
      }}
    >
      <img
        src={HarmonyIcon}
        alt="Harmony Icon"
        style={{ height: 75, paddingLeft: 8, marginRight: "0.5rem" }}
      />
      <Typography
        variant="body2"
        style={{
          textAlign: "left",
          paddingLeft: "1rem",
          paddingTop: "1rem",
          paddingBottom: "1rem",
        }}
      >
        Hoover & Strong's gold, platinum, silver, and palladium metals are
        certified 100% recycled material by SCS Global Services.
        <DomLink
          to={{
            pathname: "/sub-landing/Harmony-Recycled-Precious-Metals",
          }}
          target="_blank"
          underline="hover"
          style={{ color: "#0000FF", marginLeft: ".7rem" }} // blue color
        >
          Learn More
        </DomLink>
        {extraText && (
          <Typography
            variant="body2"
            style={{
              textAlign: "left",
              paddingTop: "1rem",
              fontSize: "1.2rem",
              fontStyle: "italic",
            }}
          >
            {extraText}
          </Typography>
        )}
      </Typography>
      <img
        src={SCSLogo}
        alt="SCS Global Services Certified 100% Recycled Material"
        style={{ height: 75 }}
      />
    </Box>
  );
}
